import { Dispatch } from "redux";
import { RepairTypes } from "../types";
import { Repair, RepairFilters, IStore } from "../../interfaces";
import { RepairProcess } from "../../api/process";


export const getRepairsAction = (filters: RepairFilters, concat?: boolean) => async (dispatch: Dispatch, getState: () => IStore) => {
    try {
        dispatch({
            type: RepairTypes.GET_REPAIRS_LOADING,
            payload: {
                loading: true,
            },
        });

        // Simulate API call delay
        const { repairs } = getState();
        const repairProcess = new RepairProcess();
        const response = await repairProcess.getRepairs(filters);

        let repairsList = [...(response.data || [])]
        if (concat && repairs.repairs?.length) {
            repairsList = [
                ...repairs.repairs,
                ...(response.data || [])
            ]
        }

        return dispatch({
            type: RepairTypes.GET_REPAIRS_SUCCESS,
            payload: {
                repairs: repairsList,
                meta: response.meta,
                filters,
                loading: false,
                success: true,
            },
        });
    } catch (error) {
        return dispatch({
            type: RepairTypes.GET_REPAIRS_FAILURE,
            payload: {
                loading: false,
                success: false,
            },
        });
    }
};

export const addRepairNoteAction = (repairId: string, note: string) => async (dispatch: Dispatch) => {
    try {
        dispatch({
            type: RepairTypes.UPDATE_REPAIR_LOADING,
            payload: {
                loading: true,
            },
        });
        const repairProcess = new RepairProcess();
        const response = await repairProcess.addRepairNote(repairId, note);
        //Reload the selected repair
        return dispatch({
            type: RepairTypes.UPDATE_REPAIR_SUCCESS,
            payload: {
                loading: false,
                success: true,
            },
        });
    } catch (error) {
        return dispatch({
            type: RepairTypes.UPDATE_REPAIR_FAILURE,
            payload: {
                loading: false,
                success: false,
            },
        });
    }
};

export const updateRepairStatusAction = (repairId: string, location?: string) => async (dispatch: Dispatch) => {
    try {
        dispatch({
            type: RepairTypes.UPDATE_REPAIR_LOADING,
            payload: {
                loading: true,
            },
        });
        const repairProcess = new RepairProcess();
        const response = await repairProcess.updateRepairStatus(repairId, location);
        // Simulate API call delay
        return dispatch({
            type: RepairTypes.UPDATE_REPAIR_SUCCESS,
            payload: {
                loading: false,
                success: true,
            },
        });
    } catch (error) {
        return dispatch({
            type: RepairTypes.UPDATE_REPAIR_FAILURE,
            payload: {
                loading: false,
                success: false,
            },
        });
    }
};

export const setRepairFilterStatus = (status: string) => (dispatch: Dispatch) => {
    return dispatch({
        type: RepairTypes.SET_REPAIR_FILTER_STATUS,
        payload: {
            filters: {
                status,
            },
        },
    });
};

export const setRepairFilterSearch = (search: string) => (dispatch: Dispatch) => {
    return dispatch({
        type: RepairTypes.SET_REPAIR_FILTER_SEARCH,
        payload: {
            filters: {
                search,
            },
        },
    });
};

export const createRepairAction = (data: { orderId: string, measurementsId: string, email: string, price: number }) => async (dispatch: Dispatch) => {
    try {
        dispatch({
            type: RepairTypes.CREATE_REPAIR_SUCCESS,
            payload: {
                loading: true,
            },
        });

        const repairProcess = new RepairProcess();
        const response = await repairProcess.createRepair(data);
        await new Promise(resolve => setTimeout(resolve, 500));
        //setTimeout(dispatch(getRepairsAction(repairFilters, isMobile)), 500);
        return dispatch({
            type: RepairTypes.CREATE_REPAIR_SUCCESS,
            payload: {
                loading: false,
                success: true,
            },
        });
    } catch (error) {
        return dispatch({
            type: RepairTypes.CREATE_REPAIR_FAILURE,
            payload: {
                loading: false,
                success: false,
            },
        });
    }
}

export const getRepairByIdAction = (repairId: string) => async (dispatch: Dispatch) => {
    dispatch({
        type: RepairTypes.GET_REPAIR_BY_ID_LOADING,
        payload: {
            loading: true,
        },
    });
    try {
        const repairProcess = new RepairProcess();
        const response = await repairProcess.getRepairById(repairId);
        return dispatch({
            type: RepairTypes.GET_REPAIR_BY_ID_SUCCESS,
            payload: {
                selectedRepair: response,
                loading: false,
                success: true,
            },
        });
    } catch (error) {
        return dispatch({
            type: RepairTypes.GET_REPAIR_BY_ID_FAILURE,
            payload: {
                loading: false,
                success: false,
            },
        });
    }
}

export const associateRepairFilesAction = (repairId: string, formData: any) => async (dispatch: (arg: Record<string, any>) => any) => {
    dispatch({
        type: RepairTypes.UPDATE_REPAIR_LOADING,
        payload: {
            loading: true,
        },
    });
    try {
        const repairProcess = new RepairProcess();
        const response = await repairProcess.associateRepairFiles(repairId, formData);
        console.log('response: ', response);
        setTimeout(dispatch(getRepairByIdAction(repairId)), 500);
        return dispatch({
            type: RepairTypes.UPDATE_REPAIR_SUCCESS,
            payload: {
                loading: false,
                success: true,
            },
        });
    } catch (error) {
        console.log('error: ', error);
        return dispatch({
            type: RepairTypes.UPDATE_REPAIR_FAILURE,
            payload: {
                loading: false,
                success: false,
            },
        });
    }
};

export const generateRepToWellingtonLabelAction = (repairId: string) => async (dispatch: Dispatch) => {
    try {
        dispatch({
            type: RepairTypes.UPDATE_REPAIR_LOADING,
            payload: {
                loading: true,
            },
        });
        const repairProcess = new RepairProcess();
        const response = await repairProcess.generateRepToWellingtonLabel(repairId);
        // Simulate API call delay
        return dispatch({
            type: RepairTypes.UPDATE_REPAIR_SUCCESS,
            payload: {
                loading: false,
                success: true,
            },
        });
    } catch (error) {
        return dispatch({
            type: RepairTypes.UPDATE_REPAIR_FAILURE,
            payload: {
                loading: false,
                success: false,
            },
        });
    }
};

export const generateCustomerToWellingtonLabelAction = (repairId: string) => async (dispatch: Dispatch) => {
    try {
        dispatch({
            type: RepairTypes.UPDATE_REPAIR_LOADING,
            payload: {
                loading: true,
            },
        });
        const repairProcess = new RepairProcess();
        const response = await repairProcess.generateCustomerToWellingtonLabel(repairId);
        // Simulate API call delay
        return dispatch({
            type: RepairTypes.UPDATE_REPAIR_SUCCESS,
            payload: {
                loading: false,
                success: true,
            },
        });
    } catch (error) {
        return dispatch({
            type: RepairTypes.UPDATE_REPAIR_FAILURE,
            payload: {
                loading: false,
                success: false,
            },
        });
    }
};